// Copyright Epic Games, Inc. All Rights Reserved.

import { Actions } from "../actions";
import {
  PATCH_ERROR_CODE_LOCALIZATION,
  PATCH_LOCALIZATION,
  PATCH_LOCALIZATION_MESSAGES,
} from "./actions";
import { initialLocalizationMessages } from "../../lang";
import { getLocale, SupportedLocale } from "./lib/getLocale";

export const localizationFeatureStoreKey = "localization";

export type LocalizationMessageIds =
  | "error.search"
  | "error.errorCode"
  | "dismiss"
  | "installation.title"
  | "cancelation.button";

export type ILocalizationMessages = Record<LocalizationMessageIds, string>;

export interface IErrorCodeLocalizationState {
  title: string;
  description: string;
}

export interface ILocalizationState {
  lang: SupportedLocale;
  messages: ILocalizationMessages;
  errorCodes: {
    [errorCode: string]: IErrorCodeLocalizationState;
    // This object will contain fallback title and description for error code
    // that we have not found.
    fallback: IErrorCodeLocalizationState;
  };
}

const locale = getLocale();
export const initialLocalizationState: ILocalizationState = {
  ...initialLocalizationMessages[locale],
  lang: locale,
};

export function localizationReducer(
  state: ILocalizationState = initialLocalizationState,
  action: Actions
): ILocalizationState {
  switch (action.type) {
    case PATCH_LOCALIZATION_MESSAGES: {
      return {
        lang: state.lang,
        messages: {
          ...state.messages,
          ...action.payload,
        },
        errorCodes: { ...state.errorCodes },
      };
    }
    case PATCH_ERROR_CODE_LOCALIZATION: {
      return {
        lang: state.lang,
        messages: {
          ...state.messages,
        },
        errorCodes: {
          ...state.errorCodes,
          [action.payload.errorCode]: {
            title: action.payload.title,
            description: action.payload.description,
          },
        },
      };
    }
    case PATCH_LOCALIZATION: {
      return {
        lang: state.lang,
        messages: {
          ...state.messages,
          ...action.payload.messages,
        },
        errorCodes: {
          ...state.errorCodes,
          ...action.payload.errorCodes,
        },
      };
    }
    default:
      return state;
  }
}
